import script from "./SavesManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavesManager.vue?vue&type=script&setup=true&lang=ts"

import "./SavesManager.vue?vue&type=style&index=0&id=7bbba367&scoped=true&lang=css"
import "./SavesManager.vue?vue&type=style&index=1&id=7bbba367&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbba367"]])

export default __exports__